import React, { Component } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { Launch, ShowChart } from '@mui/icons-material';
import Modal from './Modal';
import RouterStore from '../store/RouterStore';

interface IPropsGraficosGE {
}


export default class GraficosGerenciamentoGE extends React.Component<IPropsGraficosGE> {

    abrirEmNovaAba = () => {
        RouterStore.abrirJanela('https://link.jt.jus.br/dashboardprodutividadegabinete');
    }

    render() {
        return (
            <>
                <Tooltip title='Para solicitar acesso ao Dashboard Produtividade do Gabinete, a chefia deve abrir chamado no 4040 informando os nomes das pessoas.'>
                {/* <Tooltip title='Painel de produtividade do gabinete'> */}
                    <div color='inherit'>
                        <IconButton onClick={this.abrirEmNovaAba} color='inherit' aria-label='Painel de produtividade do gabinete. Irá abrir em uma nova janela.'>
                            <ShowChart />
                        </IconButton>
                    </div>
                </Tooltip>
                {}
            </>

        );
    }
}
